import { Radio, RadioGroup, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";

import { useStores } from "../../store/store_context";

const SelectDepartment = observer(({ page }) => {
  const { pageStore } = useStores();

  return (
    <VStack
      width={"100%"}
      padding={"10px"}
      borderRadius={"16px"}
      align={"flex-start"}
      height={"auto"}
      bg="linear-gradient(0deg,rgba(10, 10, 10, 1) 20%, rgb(24, 24, 24) 100%)"
      position="relative"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: "16px",
        padding: "2px",
        background: "linear-gradient(0deg, rgb(9, 1, 34) 0%, #3500D3 100%)",
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
      }}
    >
      <Text
        color={"myColor.white"}
        fontWeight={"600"}
        fontSize={"16px"}
        width={"100%"}
        textAlign={"center"}
      >
        Выбор отдела
      </Text>

      <RadioGroup
        value={pageStore.selected_one_department || ""}
        onChange={(e) => {
          const selectedValue = e;
          pageStore.updateSelectedOneDepartment(selectedValue || "");
          pageStore.updateSelectedOneManager("");
        }}
        color={"myColor.white"}
        fontWeight={"500"}
        colorScheme="gray"
      >
        <VStack width={"100%"} align={"flex-start"}>
          <Radio value="">Все отделы</Radio>
          {pageStore.all_departments?.length > 0
            ? pageStore.all_departments
                ?.filter((item) => item?.name != "")
                .map((item, index) => (
                  <Radio value={item?.name} key={index}>
                    {item?.name}
                  </Radio>
                ))
            : null}
        </VStack>
      </RadioGroup>
    </VStack>
  );
});

export default SelectDepartment;
